export const bookingCategoriesKeys = {
  all: () => ["bookingCategories"],
  ofPage: (perPage, page, params) => [...bookingCategoriesKeys.all(), perPage, page, params]
};
